import React from "react"

export const Iframe = ({
  src,
  minHeight,
}: {
  src: string
  minHeight: number
}) => {
  return (
    <iframe
      style={{
        width: "100%",
        border: "none",
        height: "100%",
        minHeight,
      }}
      src={src}
    />
  )
}
